export enum MemberRole {
  GUEST = 'guest',
  COLLABORATOR = 'collaborator',
  MEMBER = 'member',
  MANAGER = 'manager',
  BILLING = 'billing',
  BILLING_MANAGER = 'billing_manager'
}
